'use strict';

module.exports = require('./Select');